import { gql } from '@apollo/client';

export const MUTATION_CREATE_ENTITY_METADATA = gql`
    mutation CreateEntityMetadata($data: CreateEntityMetadataInput!) {
        createEntityMetadata(data: $data) {
            id
            enabled
            tenantUniqueId
            arMethod
            businessEntity {
                id
                displayName
            }
            tenant {
                id
                name
            }
            createdAt
            updatedAt
            createdBy {
                id
                name
            }
            updatedBy {
                id
                name
            }
        }
    }
`;

export const MUTATION_UPDATE_ENTITY_METADATA = gql`
    mutation UpdateEntityMetadata($data: UpdateEntityMetadataInput!) {
        updateEntityMetadata(data: $data) {
            id
            enabled
            tenantUniqueId
            arMethod
            businessEntity {
                id
                displayName
            }
            tenant {
                id
                name
            }
            createdAt
            updatedAt
            createdBy {
                id
                name
            }
            updatedBy {
                id
                name
            }
        }
    }
`;
